import { products } from "./mock";

export const SITE_URL = "https://izosmart.it";

export const STATIC_PAGES = {
  "/": {
    title: "Izosmart – Finestre e porte in PVC e alluminio Schüco | Avio (TN)",
    description: "Progettiamo e realizziamo serramenti in PVC e alluminio con sistemi Schüco. Sede ad Avio (TN). Richiedi un preventivo.",
  },
  "/chi-siamo": {
    title: "Chi siamo | Izosmart – Serramenti Schüco ad Avio (TN)",
    description: "Scopri chi siamo: produzione e posa di serramenti in PVC e alluminio con sistemi Schüco.",
  },
  "/prodotti": {
    title: "Prodotti – Finestre e porte Schüco in PVC e alluminio | Izosmart",
    description: "Schüco LivIng 82, LivIngSlide, TopAlu e altri sistemi per finestre, scorrevoli e porte.",
  },
  "/lavora-con-noi": {
    title: "Lavora con noi e partnership | Izosmart",
    description: "Il progetto di partnership di Izosmart per rivenditori e installatori.",
  },
  "/contatti": {
    title: "Contatti e preventivi | Izosmart – Avio (TN)",
    description: "Viale al Parco 3, Avio (TN). Tel. +39 350 950 0280, info@izosmart.com. Inviaci il tuo progetto.",
  },
  "/privacy": {
    title: "Informativa privacy | Izosmart",
    description: "Informativa sul trattamento dei dati personali di Izosmart S.r.l.",
    noindex: true,
  },
};

export const NOT_FOUND_META = {
  title: "Pagina non trovata | Izosmart",
  description: "La pagina che cerchi non esiste o è stata spostata.",
  noindex: true,
};

export const PUBLIC_PATHS = [
  ...Object.keys(STATIC_PAGES).filter((p) => !STATIC_PAGES[p].noindex),
  ...products.map((p) => `/prodotti/${p.slug}`),
];

export const getMeta = (pathname) => {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (STATIC_PAGES[path]) return { ...STATIC_PAGES[path], canonical: SITE_URL + (path === "/" ? "/" : path) };
  const product = products.find((p) => `/prodotti/${p.slug}` === path);
  if (product) {
    return { title: `${product.title} | Izosmart`, description: product.description, canonical: `${SITE_URL}${path}` };
  }
  return NOT_FOUND_META;
};
